import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { change, FormSection, Field } from 'redux-form';
import { Header, List, Form } from 'semantic-ui-react';

// Types
import { AppState } from 'services/types';

// Components
// @ts-ignore
import SchemaAttributeName from '../../../../../../../../components/SchemaAttributeName';
// @ts-ignore
import DescriptionSnippetsCheckboxGroup from './components/DescriptionSnippetsCheckboxGroup';

// Form
import { RenderCheckbox } from '../../../../../../../../forms';
import RenderReadOnly from '../../../../../../../../forms/RenderReadOnly';

// Constants
// @ts-ignore
import { FORM_NAME } from '../../../../constants';

// Selectors
// @ts-ignore
import { makeSelectFormValue } from '../../../../selectors';

interface OwnProps {
    change: Function;
    schemaAttributeId: number;
    disableIntructions?: boolean;
}

interface ConnectedProps {
    isVisible?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class SchemaAttributesListItem extends React.PureComponent<Props> {
    componentDidMount() {
        this.setFormFieldValue();
    }

    onChange() {
        // Trigger a form value change if the checkbox changes
        this.setFormFieldValue();
    }

    setFormFieldValue = () => {
        const { schemaAttributeId, isVisible, disableIntructions } = this.props;
        if (!disableIntructions && !isVisible) {
            this.props.change(
                FORM_NAME,
                `jobs[0].documentSetAttributes[${schemaAttributeId}]`,
                {
                    schemaAttributeId,
                    isVisible: false
                }
            );
        }
    };

    render() {
        const { schemaAttributeId, isVisible, disableIntructions } = this.props;

        if (disableIntructions && !isVisible) return null;

        return (
            <List.Item>
                <FormSection
                    name={
                        `jobs[0].documentSetAttributes[${schemaAttributeId}]` as string
                    }
                >
                    <Form.Field inline>
                        {!disableIntructions && (
                            <Field
                                name="isVisible"
                                component={RenderCheckbox}
                                toggle
                                onChange={() => this.onChange()}
                            />
                        )}
                        <Header sub>
                            <SchemaAttributeName
                                schemaAttributeId={schemaAttributeId}
                            />
                        </Header>
                        {disableIntructions && (
                            <Field
                                name="description"
                                component={RenderReadOnly}
                            />
                        )}
                    </Form.Field>
                    {!disableIntructions && isVisible && (
                        <DescriptionSnippetsCheckboxGroup
                            schemaAttributeId={schemaAttributeId}
                        />
                    )}
                </FormSection>
            </List.Item>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isVisible: (state: AppState, props: Props) =>
        makeSelectFormValue(
            `jobs[0].documentSetAttributes[${props.schemaAttributeId}].isVisible`
        )(state, props)
});

export default connect(mapStateToProps, { change })(SchemaAttributesListItem);
